import { render, staticRenderFns } from "./FaunaTagPreview.vue?vue&type=template&id=52a21b11&"
import script from "./FaunaTagPreview.vue?vue&type=script&lang=ts&"
export * from "./FaunaTagPreview.vue?vue&type=script&lang=ts&"
import style0 from "./FaunaTagPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports